module.exports = __webpack_public_path__ + "static/media/10quanmeitikefu.32b8dee1.png";